import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';

import { urlWithoutBasePath } from 'utils/helpers/links';

import styles from './styles.module.scss';

const Item = forwardRef(({ title, path, theme, tabIndex }, ref) => {
	const itemCx = cx(styles.item, styles[`theme_${theme}`], {
		[styles.withLink]: !!path
	});

	return (
		<div className={itemCx}>
			{path ? (
				<NextLink
					className={styles.link}
					href={urlWithoutBasePath(`/${path}`)}
					tabIndex={tabIndex}
					ref={ref}
				>
					{title}
				</NextLink>
			) : (
				<span ref={ref} tabIndex={tabIndex}>
					{title}
				</span>
			)}
			<Icon icon="chevronRight" className={styles.icon} />
		</div>
	);
});

Item.propTypes = {
	title: PropTypes.string.isRequired,
	path: PropTypes.string,
	theme: PropTypes.oneOf(['white']),
	tabIndex: PropTypes.number
};

export default Item;
